import React from 'react';
import { Button } from '@vtblife/uikit';

import {
    useClassifiedOfferDataLayerPush
} from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { offerRegionToMortgage } from '@search/vtbeco-frontend-core/domain/offer/regionToBackoffice';
import { MortgagePurpose } from '@search/graphql-typings';
import { useMortgageAction } from '../hooks/useMortgageAction';

export const OfferCardMortgageButton = ({
    scrollToMortgageCalculator,
    isAuth,
    price,
    isNewBuilding,
    regionId,
}: {
    scrollToMortgageCalculator: () => void;
    isAuth: boolean;
    price: number;
    isNewBuilding: boolean;
    regionId: number;
}) => {
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    const { goToMortgageApplication } = useMortgageAction({
        term: 20,
        propertyCost: price,
        ownAmount: price * 0.2,
        purpose: isNewBuilding ? MortgagePurpose.Primary : MortgagePurpose.Secondary,
        regionId: offerRegionToMortgage(regionId),
    });

    const handleClick = React.useCallback(() => {
        dataLayerPush({ event: 'classified_card_sale_view_ipoteka_call_back' });
        if (isAuth) {
            goToMortgageApplication();
        } else {
            scrollToMortgageCalculator();
        }
    }, [
        dataLayerPush,
        isAuth,
        scrollToMortgageCalculator,
        goToMortgageApplication
    ]);

    return (<Button
        variant='secondary'
        dataTest='mortgage-button-cta'
        onClick={handleClick}
    >
        Рассчитать ипотеку
    </Button>);
};
